import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator, ValidatorFn } from '@angular/forms';

@Directive({
  selector: '[irisInputValidator]',
  providers: [{ provide: NG_VALIDATORS, useExisting: IrisInputValidatorDirective, multi: true }],
  standalone: false,
})
export class IrisInputValidatorDirective implements Validator {
  @Input('irisInputValidator') inputValidator = '';
  validate(control: AbstractControl): ValidationErrors | null {
    return this.inputValidator ? irisInputValidator(new RegExp(this.inputValidator, 'i'))(control) : null;
  }
}

function isNullOrEmpty(value: unknown): boolean {
  return value == null || value === '';
}

export function irisInputValidator(inputRegex: RegExp, skipNullOrEmpty = false): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {

    let allowed;
    if (Array.isArray(control.value)) {
      allowed = control.value.every(v => allowed = skipNullOrEmpty && isNullOrEmpty(v) ? true : inputRegex.test(v));
    } else {
      allowed = skipNullOrEmpty && isNullOrEmpty(control.value) ? true : inputRegex.test(control.value);
    }

    return !allowed ? { inputValidator: true } : null;
  };
}
